// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-P6-","controls":"styles_controls__UHkI5","charLimit":"styles_charLimit__3G3Vg","input":"styles_input__30raG","send":"styles_send__2L7aZ"};